export class Response_1 {
  constructor(
    public motivationReason: string | null,
    public demotivationReason: string | null
  ) {
    this.motivationReason = motivationReason;
    this.demotivationReason = demotivationReason;
  }

  static init = () => new Response_1(null, null);
}
